
  import { defineComponent } from "vue"

  export default defineComponent({
    name: "ScannerWords",
    inject: ["Ti18N"],
    setup(_: any, { emit }: any) {
      
      return {}
    },
  })
